import type { Home, User } from '@lmc/ts-common'
import { useAbilityAccess } from 'components/AccessControl'
import useHomeType from 'hooks/useHomeType'
import type { FC } from 'react'
import { Dropdown } from '../../../LEGACY/elemental'
import { history } from '../../../store'
import CONSTANTS from '../../../utils/constants'
import { getInsightsHubLink } from '../../../utils/sso'
import { ProfilePicture } from '../../generic/ProfilePicture'
import { getProfileMenuItems } from '../utils'

type Props = {
  handleSignout: () => void
  handleHomeSwitch: () => void
  handleSwitchOfficer: () => void
  handleManageAccount: () => void
  user: User
  home: Home
  onHover?: boolean
}

export const ProfileItem: FC<Props> = ({
  handleSignout,
  handleHomeSwitch,
  handleSwitchOfficer,
  handleManageAccount,
  user,
  home,
  onHover
}) => {
  const handleSelect = (path: string) => {
    if (path === 'signout') {
      handleSignout()
    } else if (path === 'switch') {
      handleHomeSwitch()
    } else if (path === 'admin-view') {
      handleSwitchOfficer()
    } else if (path === 'privacy-officer-view') {
      handleSwitchOfficer()
    } else if (path === 'manage-account') {
      handleManageAccount()
    } else if (path === 'insights-hub') {
      window.open(getInsightsHubLink(), '_blank')
    } else {
      history.push(`/${path}`)
    }
  }

  const isPrivacyOfficer = () => {
    return home.privacyOfficers
      ?.map((officer) => officer?.user)
      ?.includes(user?.id)
  }

  const canManageHome = useAbilityAccess([{ i: 'update', this: 'Home' }])
  const canAccessInsightsHub = useAbilityAccess([
    { i: 'view', this: 'InsightsHub' }
  ])
  const { isOutstanding } = useHomeType()

  // Being listed in home.privacyOfficers is the sole qualifying check; we do
  // NOT gate on canManageHome. Management role users may be Privacy Officers
  // without holding the 'update Home' ability.
  const privacyOfficerEnabled = isPrivacyOfficer()

  const insightsHubEnabled =
    !CONSTANTS.PROD || (canAccessInsightsHub && isOutstanding)

  return (
    <Dropdown
      items={getProfileMenuItems(
        user,
        privacyOfficerEnabled,
        canManageHome,
        insightsHubEnabled
      )}
      onSelect={(item: string) => handleSelect(item)}
      alignRight
      onHover={onHover}
      data-cy="profile-dropdown"
    >
      <div style={styles.container}>
        <ProfilePicture
          style={styles.profilePic}
          type="small"
          url={user && user.picture}
          alt=""
        />
      </div>
    </Dropdown>
  )
}

const styles = {
  container: {
    cursor: 'pointer'
  },
  menu: {
    position: 'relative',
    top: 30,
    color: 'black'
  },
  profilePic: {
    backgroundSize: 30,
    height: 33,
    width: 33
  }
}
